// @ts-nocheck

import { stopAction } from '../actions/common';
import { selectEntitiesMatchesEntityIsOutright } from '../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { BasketActionTypes } from '../types/actions/basket';
import { type StoreType, type GenericAction } from '../types/redux';

const handledActionTypes = [BasketActionTypes.OUTCOME_SELECTED, BasketActionTypes.OUTCOME_UNSELECTED];

const basketActionsInterceptorMiddleware =
  ({ getState }: StoreType) =>
  (next: (action: GenericAction) => unknown) =>
  (action: GenericAction) => {
    const { type: actionType, payload: actionPayload } = action;

    if (~handledActionTypes.indexOf(actionType)) {
      const state = getState();
      const { basket: basketState } = state;
      const { isCashout: basketIsCashout, items: basketItems } = basketState;
      const { matchId: actionPayloadMatchId } = actionPayload ?? {};

      const isMatchOutright = selectEntitiesMatchesEntityIsOutright(state, { matchId: actionPayloadMatchId });
      const cashoutedBasketItemsMatchIds = Object.keys(basketItems).reduce(
        (acc, itemId) =>
          basketItems[itemId].matchId && basketItems[itemId].cashout ? [...acc, basketItems[itemId].matchId] : acc,
        [],
      );

      if (~cashoutedBasketItemsMatchIds.indexOf(actionPayloadMatchId) && basketIsCashout && !isMatchOutright) {
        return next(stopAction({ stoppedAction: action }));
      }
    }

    return next(action);
  };

export default basketActionsInterceptorMiddleware;
